import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/registro_sanitario/linea';
import Linea from './Linea';


const ms2p = (state) => {
  return {
    ...state.rs_linea,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Linea);